import UserAvailable from "@/entities/filters/UserAvailable";

const locationCollectionFiltersTemplate = {
  name: "",
  countries: [],
  states: [],
  cities: [],
  available: "all" as UserAvailable,
  titles: [],
  skills: [],
  managers: [],
  projects: [],
  minRate: "",
  maxRate: "",
};

export default locationCollectionFiltersTemplate;